export default "__VITE_ASSET__bp45eGlL__"